define( [
	"./arr"
], function( arr ) {
	return arr.push;
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/var/push.js
// module id = 295
// module chunks = 0